import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Plane } from "lucide-react";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine, LabelList } from "recharts";
import { fmt, tooltipStyle } from "./oversiktConstants";
import { dec, num } from "@/lib/formatters";

const KorttidCompareChart = ({ korttidData, colors }) => {
  const rows = Object.values(korttidData || {}).filter((k) => k.andel_pct != null);
  if (rows.length === 0) return null;
  const land = rows.find((r) => r.land_pct != null)?.land_pct;
  const data = rows.map((r) => ({ name: `${r.name} (${r.fylke_name})`, andel: r.andel_pct, antall: r.ikke_bosatte }));
  return (
    <Card className="bg-white border border-[#E6E9F0] rounded-lg lg:col-span-2" data-testid="compare-korttid-chart">
      <CardHeader className="border-b border-[#E6E9F0] pb-4">
        <CardTitle className="text-lg font-medium text-[#1F2A36] flex items-center gap-2 flex-wrap">
          <Plane className="w-5 h-5 text-[#103766]" />
          Sysselsette på korttidsopphald {rows[0].year}
          <Badge variant="outline" className="border-[#E8A34A] text-[#B8741F] bg-[#FDF6EA] text-[10px] uppercase">Fylkestal</Badge>
        </CardTitle>
        <p className="text-sm text-[#4B647F]">Lønstakarar som ikkje er registrert busett, i prosent av alle sysselsette i fylket kommunen ligg i. SSB publiserer ikkje tal per kommune{land ? `; landet: ${dec(land, 1)} %` : ""}.</p>
      </CardHeader>
      <CardContent className="pt-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="h-[280px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} barCategoryGap="35%" margin={{ top: 20 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E6E9F0" />
              <XAxis dataKey="name" stroke="#8AA4BF" fontSize={11} interval={0} />
              <YAxis stroke="#8AA4BF" fontSize={12} tickFormatter={(v) => `${num(v)} %`} />
              <Tooltip formatter={(v, _n, p) => [`${dec(v, 1)} % (${fmt(p.payload.antall)} personar)`, "Andel ikkje-busette"]} contentStyle={tooltipStyle} />
              {land && <ReferenceLine y={land} stroke="#4B647F" strokeDasharray="4 4" label={{ value: "Landet", position: "insideTopRight", fontSize: 11, fill: "#4B647F" }} />}
              <Bar dataKey="andel" radius={[4, 4, 0, 0]}>
                {data.map((d, i) => <Cell key={d.name} fill={colors[i % colors.length]} />)}
                <LabelList dataKey="andel" position="top" formatter={(v) => `${dec(v, 1)} %`} fontSize={12} fill="#1F2A36" />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="space-y-3" data-testid="compare-korttid-land">
          {rows.map((r, i) => (
            <div key={r.name} className="p-3 border border-[#E6E9F0] rounded-lg" data-testid={`compare-korttid-${r.name}`}>
              <p className="text-xs text-[#8AA4BF] flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-sm inline-block" style={{ background: colors[i % colors.length] }} />{r.fylke_name}: {fmt(r.ikke_bosatte)} ikkje-busette lønstakarar</p>
              <p className="text-sm text-[#1F2A36]">Flest fra {r.top_land.map((l) => `${l.name} (${fmt(l.count)})`).join(", ")}</p>
            </div>
          ))}
          <p className="text-xs text-[#8AA4BF]">Kjelde: SSB 11610, sysselsette 20–66 år, 4. kvartal.</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default KorttidCompareChart;
